// Matches [label](url) where url is http(s):// or mailto:.
// Scheme allowlist guards against [click](javascript:...) — React does not
// sanitize href, so the regex is the only line of defense.
const LINK_RE = /\[([^\]]+)\]\(((?:https?:\/\/|mailto:)[^)]+)\)/g;

export type MarkdownSegment = string | { label: string; url: string };

export function parseMarkdownLinks(text: string): MarkdownSegment[] {
  if (!text) return [];
  const segments: MarkdownSegment[] = [];
  let lastIndex = 0;
  for (const match of text.matchAll(LINK_RE)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      segments.push(text.slice(lastIndex, start));
    }
    segments.push({ label: match[1], url: match[2] });
    lastIndex = start + match[0].length;
  }
  if (lastIndex < text.length) {
    segments.push(text.slice(lastIndex));
  }
  return segments;
}

export function stripMarkdownLinks(text: string): string {
  return text.replace(LINK_RE, "$1");
}
